import { EChartsOption } from 'echarts';
import PieChart from 'lib/Charts/PieChart';
import { DASH_SLASH } from 'consts/placeholders';
import { EmptyPieChartProps } from './EmptyPieChart.types';

const EmptyPieChart: React.FC<EmptyPieChartProps> = ({ onChartClick }) => {
  const ctPieChartColor = ['#c0c0c0'];

  const chartOptions: EChartsOption = {
    backgroundColor: 'transparent',
    series: [
      {
        type: 'pie',
        emphasis: {
          disabled: true,
        },
      },
    ],
  };

  const getChartData = (): { name: string; value: number }[] => {
    return [
      {
        name: 'Empty',
        value: 1,
      },
    ];
  };

  const chartData = getChartData();

  return (
    <div className="relative flex items-center body-sm text-neutral-600">
      <PieChart
        dataTestId="empty-pie-chart"
        colors={ctPieChartColor}
        data={chartData}
        options={chartOptions}
        hasDataLabel={false}
        hasEnabledExporting={false}
        hasTooltip={false}
        chartHeight="60px"
        chartWidth="60px"
        chartSize="70%"
        onClick={onChartClick}
      />
      <div className="relative w-40 inline-block">
        <div className="mb-1">
          <span className="h-2.5 w-2.5 inline-block mr-2 rounded-sm" style={{ backgroundColor: ctPieChartColor[0] }} />
          {DASH_SLASH}
        </div>
        <div>
          <span className="h-2.5 w-2.5 inline-block mr-2 rounded-sm" style={{ backgroundColor: ctPieChartColor[0] }} />
          {DASH_SLASH}
        </div>
      </div>
      <div className="relative w-60 inline-block pl-2.5 border-l border-neutral-300 border-solid">
        <div className="mb-1">{DASH_SLASH}</div>
        <div>{DASH_SLASH}</div>
      </div>
    </div>
  );
};

export default EmptyPieChart;
